import { NgModule } from '@angular/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ChartModule } from 'angular2-chartjs';
import {
  NbCheckboxModule,
  NbTabsetModule,
  NbToggleModule,
  NbSelectModule,
  NbProgressBarModule,
  NbDialogModule,
  NbPopoverModule,
  NbFormFieldModule,
  NbAutocompleteModule,
  NbIconModule,
  NbAlertModule,
  NbButtonModule,
} from '@nebular/theme';

import {
  AdjustMetricsGraphComponent,
  MealMetricsGraphComponent,
} from './meal-metrics-graph.component';

const NB_MODULES = [
  NbEvaIconsModule,
  NbButtonModule,
  NbAlertModule,
  NbIconModule,
  NbCheckboxModule,
  NbTabsetModule,
  NbToggleModule,
  NbSelectModule,
  NbProgressBarModule,
  NbDialogModule,
  NbPopoverModule,
  NbFormFieldModule,
  NbAutocompleteModule,
];

@NgModule({
  imports: [...NB_MODULES, ChartModule],
  declarations: [MealMetricsGraphComponent, AdjustMetricsGraphComponent],
  exports: [MealMetricsGraphComponent, AdjustMetricsGraphComponent],
})
export class GraphModule {}
